import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { applicationOptions } from '../../stores/applications/selectors';
import { RootState } from '../../stores/store';
import { selectAll, unselectAll } from '../../stores/tables/actionCreators';
import TableColumn from '../table/TableColumn';
import TableFilterableColumn from '../table/TableFilterableColumn';
import TableHead from '../table/TableHead';
import TableSelectionColumn from '../table/TableSelectionColumn';
import TableSortableColumn from '../table/TableSortableColumn';

interface Props extends LocalizeContextProps {
    refresh: () => void;
    ids: string[];

    selectAll: (ids: string[]) => void;
    unselectAll: (ids: string[]) => void;

    applicationOptions: Array<{ label: string, value: string }>;
}

class ServersTableHead extends React.Component<Props> {
    public render() {
        const t = this.props.translate;
        return (
            <TableHead>
                <TableSelectionColumn
                    itemIds={this.props.ids}
                    tableKey="servers"
                    selectAll={() => this.props.selectAll(this.props.ids)}
                    deselectAll={() => this.props.unselectAll(this.props.ids)}
                />
                <TableColumn className="icon-btn-th" />
                <TableSortableColumn
                    tableKey="servers"
                    column="hostname"
                    refresh={this.props.refresh}
                >
                    {t('servers.table.header.hostname')}
                </TableSortableColumn>
                <TableSortableColumn
                    tableKey="servers"
                    column="secure"
                    refresh={this.props.refresh}
                >
                    {t('servers.table.header.secure')}
                </TableSortableColumn>
                <TableSortableColumn
                    tableKey="servers"
                    column="atp_url"
                    refresh={this.props.refresh}
                >
                    {t('servers.table.header.atpUrl')}
                </TableSortableColumn>
                <TableColumn>
                    {t('servers.table.header.anagoVersion')}
                </TableColumn>
                <TableFilterableColumn
                    tableKey="servers"
                    columnName={t('servers.table.header.applications') as string}
                    filterKey="a"
                    options={this.props.applicationOptions}
                    refresh={this.props.refresh}
                />
                <TableColumn className="icon-btn-th"/>
                <TableColumn className="icon-btn-th"/>
            </TableHead>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    applicationOptions: applicationOptions(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  selectAll: (ids: string[]) => dispatch(selectAll('servers', ids)),
  unselectAll: (ids: string[]) => dispatch(unselectAll('servers', ids)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(ServersTableHead));